import type { PreviewCardProps } from './types'

import { emotionTheme } from '@styles/theme'

import * as S from './styles'

export const PreviewCard = ({ label, value, icon, bottomText, infoIcon, isBudget }: PreviewCardProps) => {
  const isNegative = value.startsWith('-')

  return (
    <S.Container>
      <S.LeftBox>
        <S.Label>
          {label}
          {!!infoIcon && infoIcon}
        </S.Label>

        <S.Value
          style={{
            color: isBudget
              ? emotionTheme.colors.secondary
              : isNegative
                ? emotionTheme.colors.error.color
                : emotionTheme.colors.success.color
          }}
        >
          {value}
        </S.Value>

        <S.BottomText>{bottomText}</S.BottomText>
      </S.LeftBox>

      <S.IconBox
        style={{
          color: isBudget
            ? emotionTheme.colors.primary
            : isNegative
              ? emotionTheme.colors.error.color
              : emotionTheme.colors.success.color,
          background: isBudget
            ? emotionTheme.colors.gray.light
            : isNegative
              ? emotionTheme.colors.error.background
              : emotionTheme.colors.success.background
        }}
      >
        {icon}
      </S.IconBox>
    </S.Container>
  )
}
